import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/**
 * Paginated list of a patient's appointments, server-filtered + sorted
 * by `timeframe`:
 *   UPCOMING - from start of today onwards, soonest-first.
 *   PREVIOUS - before today, most-recent-first.
 *
 * Day boundary, filtering and ordering are all enforced server-side —
 * do NOT re-sort or date-filter on the client.
 */
export const usePatientAppointmentsPaginatedList = ({
  patientId,
  timeframe,
  page,
  rows = 10,
}) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [
      "patientAppointmentsPaginatedList",
      patientId,
      tenantVal,
      timeframe,
      page,
      rows,
    ],
    queryFn: async () => {
      if (!patientId) return null;
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/appointment/getbypatientid/${patientId}/timeframe?timeframe=${timeframe}&page=${page}&rows=${rows}`
      );
      return response.data;
    },
    enabled: !!patientId && !!tenantVal,
    staleTime: 1000 * 60 * 5,
    meta: { errorMessage: "Error fetching patient appointments" },
  });
};
